import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IPrescriptionFulfillmentModel extends IModel {
  prescriptionFulfillmentId: number;
  name: string;
  packageItemCount: number;
  packageRefillDays: number;
  packagesSold: number;
  packagesForYear: number;
  packagesSoldRefillDays: number;
  adminNotes: string;
}

export class PrescriptionFulfillmentModel
  extends Model
  implements ModelRecord<IPrescriptionFulfillmentModel>
{
  prescriptionFulfillmentId: number;
  name: string;
  packageItemCount: number;
  packageRefillDays: number;
  packagesSold: number;
  packagesForYear: number;
  packagesSoldRefillDays: number;
  adminNotes: string;
  constructor(params?: Partial<IPrescriptionFulfillmentModel>) {
    super(params);
    this.prescriptionFulfillmentId = defaultTo(
      params?.prescriptionFulfillmentId,
      0,
    );
    this.name = defaultTo(params?.name, '');
    this.packageItemCount = defaultTo(params?.packageItemCount, 0);
    this.packageRefillDays = defaultTo(params?.packageRefillDays, 0);
    this.packagesSold = defaultTo(params?.packagesSold, 0);
    this.packagesForYear = defaultTo(params?.packagesForYear, 0);
    this.packagesSoldRefillDays = defaultTo(params?.packagesSoldRefillDays, 0);
    this.adminNotes = defaultTo(params?.adminNotes, '');
  }
}
